var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomProjectEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.54 43.9999H89.425C101.885 43.9999 105 47.1149 105 59.5399V81.6949C105 94.1549 101.885 97.2349 89.46 97.2349H50.54C38.115 97.2699 35 94.1549 35 81.7299V59.5399C35 47.1149 38.115 43.9999 50.54 43.9999Z",
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60 59V67C60 69.4 58.5 71 55 71H47C43.5 71 42 69.4 42 67V59C42 56.6 43.5 55 47 55H55C58.5 55 60 56.6 60 59Z",
    stroke: "#E9E9E9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47 61H51",
    stroke: "#E9E9E9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47 65H55",
    stroke: "#E9E9E9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634001"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170",
    x: 64,
    y: 19,
    width: 34,
    height: 37,
    rx: 5,
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167",
    x: 81,
    y: 27,
    width: 14,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172",
    x: 69,
    y: 37,
    width: 25,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173",
    x: 69,
    y: 43,
    width: 25,
    height: 7,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171",
    x: 69,
    y: 23,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70 97.2698V114",
    stroke: "#E9E9E9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36 82.5H104",
    stroke: "#E9E9E9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M75 73L96 73",
    stroke: "#E9E9E9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M75 67L96 67",
    stroke: "#E9E9E9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M54.25 114H85.75",
    stroke: "#E9E9E9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomProjectEmpty);
export default __webpack_public_path__ + "static/media/customProjectEmpty.520179ee7d94d4312cd1bcf670ac24e2.svg";
export { ForwardRef as ReactComponent };